<div class="cart-group-metadata">
  <a
    [class]="{
      'cart-group-metadata__link': true,
      'cart-group-metadata__link--full-width': !!courthouseFullWidth(),
    }"
    [routerLink]="courthousePath()"
  >
    <ftr-icon class="cart-group-metadata__icon" icon="Courthouse" size="Small" />
    <span>{{ group().courthouse.name }}</span>
  </a>
  <a class="cart-group-metadata__link" [routerLink]="courtroomPath()">
    <ftr-icon class="cart-group-metadata__icon" icon="Courtroom" size="Small" />
    <span>{{ group().courtroom.name }}</span>
  </a>
  <a class="cart-group-metadata__link" [routerLink]="datePath()" [queryParams]="dateQueryParam()">
    <ftr-icon class="cart-group-metadata__icon" icon="CalendarDay" size="Small" />
    <ftr-date [date]="group().recordingDate" [format]="dateFormat" />
  </a>
</div>
